import type { StateStore } from "../app/state/StateStore";
import type { KeysElementModel } from "../elements/KeysElement";

import { BaseBlock } from "./BaseBlock";

import { KeysElement } from "../elements/KeysElement";

/**
 * Block задания Keys.
 *
 * Владеет TeachingElement задания Keys.
 */
export class KeysBlock extends BaseBlock {

    private readonly task: any;

    private readonly taskIndex: number;

    private readonly store: StateStore;

    private readonly elements =
        new Map<number, KeysElement>();

    constructor(
        task: any,
        taskIndex: number,
        store: StateStore
    ) {

        super();

        this.task = task;
        this.taskIndex = taskIndex;
        this.store = store;

    }

    public override mount(): void {

        this.root = this.render();

        super.mount();

    }

    public override update(): void {

        const newRoot =
            this.render();

        this.root.replaceWith(
            newRoot
        );

        this.root =
            newRoot;

    }

    public override unmount(): void {

        for (const element of this.elements.values()) {
            element.unmount();
        }

        this.elements.clear();

        super.unmount();

    }

    private render(): HTMLElement {

        const wrapper = document.createElement("div");

        wrapper.className =
            "task keys-task card";

        wrapper.innerHTML = this.task.html;

        const gapNodes =
            wrapper.querySelectorAll<HTMLElement>(".krok-gap");

        gapNodes.forEach(node => {

            const gapId = Number(node.dataset.gapId);

            if (!this.task.gaps[gapId]) {
                return;
            }

        const element =
            new KeysElement(
                this.createKeysModel(gapId)
            );

            element.mount();

            this.elements.set(
                gapId,
                element
            );

            node.replaceWith(
                element.getRoot()
            );

        });

        const button =
            document.createElement("button");

        button.className = "gap-btn";

        button.addEventListener(
            "click",
            () => {

                this.toggleReveal();

            }
        );

        button.textContent =
            this.store.getState().revealed[this.taskIndex]
                ? "Зробити ще раз"
                : "Відповідь";

        wrapper.appendChild(button);

        return wrapper;

    }


    private createKeysModel(
        gapId: number
    ): KeysElementModel {

        const state =
            this.store.getState();

        const gap =
            this.task.gaps[gapId];

        return {

            answer:
                gap.value,

            revealed:
                !!state.revealed[this.taskIndex]

        };

    }

    private toggleReveal(): void {

        const state =
            this.store.getState();

        const isRevealed =
            !!state.revealed[this.taskIndex];

        this.store.update(prev => {

            if (isRevealed) {

                const {
                        [this.taskIndex]: _,
                        ...revealed
                    } = prev.revealed;

                    return {

                        ...prev,

                        revealed

                    };

            }

            return {

                ...prev,

                revealed: {

                    ...prev.revealed,

                    [this.taskIndex]: true

                }

            };

        });

        this.update();

    }

}